<template>
  <fmv-sidebar ref="sidebar" :type="sidebarType" :variant="sidebarVariant" @update="scrollIntoView">
    <!-- Search -->
    <div v-if="sidebarSearch" class="d-flex align-items-center navbar-height">
      <b-form class="search-form w-100 mx-16pt pr-0 pl-16pt" :class="sidebarSearchFormClass">
        <b-form-input :placeholder="$t('Search')" type="text" class="pl-0" />
        <b-button variant="none">
          <md-icon>search</md-icon>
        </b-button>
      </b-form>
    </div>
    <!-- // END Search -->

    <span v-if="sidebarBrand" class="sidebar-brand" :class="sidebarBrandClass">
      <b-img :src="brandImage" width="40" class="mb-3" alt="logo" />
      <span v-text="sidebarBrand" />
    </span>

    <slot v-bind:sidebar="{ menu }">
      <template v-if="sidebarMenu">
        <!-- Sidebar routes -->

        <template v-if="get(getLoggedInUser, 'role') === USER_ROLES.SUPER_ADMIN">
          <!-- <div class="sidebar-heading"></div> -->
          <sidebar-menu :menu="menu.superAdmin" class="mb-24pt" />
        </template>

        <template v-else-if="get(getLoggedInUser, 'role_type') === USER_ROLE_TYPES.SCHOOL">
          <div class="sidebar-heading">Home</div>
          <sidebar-menu :menu="menu.school_home" />
          <ul class="sidebar-menu mb-0">
            <li class="sidebar-menu-item">
              <a @click.prevent="openStdModal" class="sidebar-menu-button" target="_blank"
                ><i class="material-icons sidebar-menu-icon sidebar-menu-icon--left">web</i>
                <span class="sidebar-menu-text">Student Center</span>
              </a>
            </li>
          </ul>
          <div class="sidebar-heading mt-2">Academics</div>
          <sidebar-menu :menu="menu.school_academics" ref="schoolSideMenu" :key="schoolKey" />
          <div class="sidebar-heading mt-2">LMS</div>
          <sidebar-menu :menu="menu.school_lms" />
          <div class="sidebar-heading mt-2">Tools</div>
          <sidebar-menu :menu="menu.school_tools" />
          <sidebar-menu :menu="childrenArr" :badge="getPartnershipStatus" />
          <!-- <sidebar-menu :menu="menu.school" class="" ref="schoolSideMenu" /> -->
        </template>

        <template v-else-if="get(getLoggedInUser, 'role_type') === USER_ROLE_TYPES.PARTNER">
          <!-- <div class="sidebar-heading"></div> -->
          <sidebar-menu :menu="menu.partner" class="mb-24pt" />
        </template>

        <template v-else-if="get(getLoggedInUser, 'role_type') === USER_ROLE_TYPES.EMPLOYER">
          <!-- <div class="sidebar-heading"></div> -->
          <sidebar-menu :menu="menu.employer" />
          <div class="sidebar-heading">Home</div>
          <sidebar-menu :menu="menu.employer_home" />
          <div class="sidebar-heading mt-2">CRM</div>
          <sidebar-menu :menu="menu.employer_crm" />
          <div class="sidebar-heading mt-2">Tools</div>
          <sidebar-menu :menu="menu.employer_tools" />
          <div class="sidebar-heading mt-2" v-if="get(getLoggedInUser, 'linked_entity.organization')">Website</div>
          <sidebar-menu :menu="menu.employer_cs_analytics" />
        </template>

        <template v-else-if="get(getLoggedInUser, 'role') === USER_ROLES.STUDENT">
          <!-- <div class="sidebar-heading"></div> -->
          <sidebar-menu :menu="menu.student" class="mb-24pt mt-4" />
        </template>

        <template v-else-if="get(getLoggedInUser, 'role') === USER_ROLES.ORGANIZATION">
          <div class="sidebar-heading">Home</div>
          <sidebar-menu :menu="menu.org_home" />
          <div class="sidebar-heading mt-2">CRM</div>
          <sidebar-menu :menu="menu.org_crm" />
          <div class="sidebar-heading mt-2">Tools</div>
          <sidebar-menu :menu="menu.org_tools" />
          <template v-if="isOrgToolEnabled('website')">
            <div class="sidebar-heading mt-2">Website</div>
            <sidebar-menu :menu="menu.org_cs" />
          </template>
          <ul
            class="sidebar-menu"
            v-if="isOrgToolEnabled('website') && get(getLoggedInUser, 'linked_entity.organization_site.wbst_domain')"
          >
            <li class="sidebar-menu-item">
              <a
                :href="getClickableLink(get(getLoggedInUser, 'linked_entity.organization_site.wbst_domain'))"
                class="sidebar-menu-button"
                target="_blank"
                ><i class="material-icons sidebar-menu-icon sidebar-menu-icon--left">visibility</i>
                <span class="sidebar-menu-text">View Site</span>
              </a>
            </li>
          </ul>
        </template>

        <template v-else>
          <!-- School's website link for public pages. -->
          <!-- <ul class="sidebar-menu mb-0 mt-4" v-if="get(getCurrentSchool, 'website_url')">
            <li class="sidebar-menu-item">
              <a
                :href="getClickableLink(get(getCurrentSchool, 'website_url'))"
                class="sidebar-menu-button"
                target="_blank"
                ><i class="material-icons sidebar-menu-icon sidebar-menu-icon--left">home</i>
                <span class="sidebar-menu-text">Home</span>
              </a>
            </li>
          </ul> -->

          <sidebar-menu :menu="menu.unauthRoutes" class="mb-24pt mt-4" />
        </template>

        <!-- <template>
          <div class="sidebar-heading"></div>
          <sidebar-menu :menu="i18nMenu.student" class="mb-24pt" />
        </template>

        <template v-if="menu.components && menu.components.length">
          <div class="sidebar-heading">{{ $t('Components') }}</div>
          <sidebar-menu :menu="i18nMenu.components" class="mb-24pt" />
        </template> -->
      </template>
    </slot>
    <std-center-modal :show-modal="showStdModal" @close="hideStdModal" />
  </fmv-sidebar>
</template>

<script>
import MdIcon from '@/components/Ui/MdIcon.vue';
import routeToMixin from '@/mixins/route-to';
import { FmvSidebar } from 'fmv-layout';
import { get } from 'lodash';
import { elementScrollIntoView } from 'seamless-scroll-polyfill';
import { mapActions, mapGetters } from 'vuex';

import { SCH_PAYMENT_PLANS, USER_ROLES, USER_ROLE_TYPES } from '../../common/constants';

import brandImage from '@/assets/images/logos/logo_icon.png';
import StdCenterModal from '../../views/SchoolPortal/StudentCenter/StdCenterModal.vue';
import SidebarMenu from './SidebarMenu.vue';

export default {
  components: {
    FmvSidebar,
    SidebarMenu,
    MdIcon,
    StdCenterModal,
  },
  mixins: [routeToMixin],
  props: {
    sidebarType: {
      type: String,
      default: () => 'dark-pickled-bluewood',
    },
    sidebarVariant: {
      type: String,
      default: () => null,
    },
    sidebarBrand: {
      type: [String, Boolean],
      default: () => 'Brand',
    },
    brandImage: {
      type: String,
      default() {
        return brandImage;
      },
    },
    sidebarBrandClass: {
      type: [Array, String, Object],
      default: null,
    },
    sidebarSearch: {
      type: Boolean,
      default: true,
    },
    sidebarSearchFormClass: {
      type: [Array, String, Object],
      default: () => null,
    },
    sidebarMenu: {
      type: Object,
      default: () => null,
    },
  },
  data() {
    return {
      USER_ROLES,
      USER_ROLE_TYPES,
      SCH_PAYMENT_PLANS,
      scrollIntoViewElement: null,
      subdomain: '',
      showStdModal: false,
      dropDownVisible: false,
      arePartnershipPending: false,
      childrenArr: [
        {
          label: 'Partnerships',
          icon: { type: 'md-icon', id: 'business' },
          id: 'partnerships',
          children: [
            {
              label: 'Partnership Profile',
              route: { name: 'partnership-profile' },
              exact: true,
            },
            {
              label: 'Employers',
              route: { name: 'manage-partnerships' },
            },
            {
              label: 'Universities',
              route: { name: 'manage-partnered-universities' },
              exact: true,
            },
            {
              label: 'Workforce Programs',
              route: { name: 'manage-high-school-districts' },
              exact: true,
            },
            {
              label: 'Organizations',
              route: { name: 'manage-school-organizations' },
              exact: true,
            },
          ],
        },
      ],
      isPaid: false,
      schoolKey: 'school',
      // menu: {
      //   default: [
      //     {
      //       label: this.$t('home'),
      //       route: { name: 'home' },
      //       icon: { type: 'md-icon', id: 'home' },
      //     },
      //   ],
      //   superAdmin: [
      //     {
      //       label: this.$t('home'),
      //       route: { name: 'admin-dashboard' },
      //       icon: { type: 'md-icon', id: 'home' },
      //     },
      //     {
      //       label: 'Users',
      //       route: { name: 'manage-users' },
      //       icon: { type: 'md-icon', id: 'person' },
      //     },
      //     {
      //       label: 'Partnerships',
      //       route: { name: 'manage-all-partnerships' },
      //       icon: { type: 'md-icon', id: 'business' },
      //     },
      //     {
      //       label: 'Feature Updates',
      //       route: { name: 'manage-features' },
      //       icon: { type: 'md-icon', id: 'lightbulb' },
      //     },

      //     // {
      //     //   label: this.$t('schoolMsgs.schools'),
      //     //   route: { name: 'manage-schools' },
      //     //   icon: { type: 'md-icon', id: 'account_balance' },
      //     // },
      //     {
      //       label: this.$t('schoolMsgs.schools'),
      //       icon: { type: 'md-icon', id: 'account_balance' },
      //       id: 'schools-admin-account',
      //       children: [
      //         {
      //           label: 'School Accounts',
      //           route: { name: 'manage-schools' },
      //           icon: { type: 'md-icon', id: 'account_balance' },
      //         },
      //         {
      //           label: 'Interested Schools',
      //           route: { name: 'manage-interested-schools' },
      //           icon: { type: 'md-icon', id: 'account_balance' },
      //         },
      //       ],
      //     },
      //     {
      //       label: this.$t('studentMsgs.students'),
      //       route: { name: 'manage-students' },
      //       icon: { type: 'md-icon', id: 'school' },
      //     },
      //     {
      //       label: this.$t('employerMsgs.employers'),
      //       route: { name: 'manage-employers' },
      //       icon: { type: 'md-icon', id: 'business' },
      //     },
      //     {
      //       label: 'Organizations',
      //       route: { name: 'manage-organizations' },
      //       icon: { type: 'md-icon', id: 'business_center' },
      //     },
      //     {
      //       label: 'Partners',
      //       route: { name: 'manage-partners' },
      //       icon: { type: 'md-icon', id: 'group' },
      //     },
      //     {
      //       label: 'Initiative Sites',
      //       icon: { type: 'md-icon', id: 'settings' },
      //       id: 'website-config',
      //       children: [
      //         {
      //           label: 'Basic',
      //           route: { name: 'basic-config' },
      //           icon: { type: 'md-icon', id: 'settings' },
      //         },
      //         {
      //           label: 'Home',
      //           route: { name: 'homepage-config' },
      //           icon: { type: 'md-icon', id: 'settings' },
      //         },
      //         {
      //           label: 'Pages',
      //           route: { name: 'pages-config' },
      //           icon: { type: 'md-icon', id: 'settings' },
      //         },
      //       ],
      //     },
      //     {
      //       label: 'Career Preferences',
      //       route: { name: 'sa-manage-career-preferences' },
      //       icon: { type: 'md-icon', id: 'local_hospital' },
      //     },
      //     {
      //       label: 'Programs',
      //       route: { name: 'sa-manage-programs' },
      //       icon: { type: 'md-icon', id: 'local_library' },
      //     },
      //     {
      //       label: 'Jobs',
      //       route: { name: 'jobs-management-list' },
      //       icon: { type: 'md-icon', id: 'work' },
      //     },

      //     {
      //       label: 'Events',
      //       route: { name: 'sa-manage-events' },
      //       icon: { type: 'md-icon', id: 'event' },
      //     },
      //     {
      //       label: 'Blogs',
      //       route: { name: 'sa-manage-blogs' },
      //       icon: { type: 'md-icon', id: 'vignette' },
      //     },
      //     {
      //       label: 'Resources',
      //       route: { name: 'manage-resources' },
      //       icon: { type: 'md-icon', id: 'folder' },
      //     },
      //     {
      //       label: 'Sponsored Training',
      //       icon: { type: 'md-icon', id: 'location_on' },
      //       id: 'location',
      //       children: [
      //         {
      //           label: 'States',
      //           route: { name: 'sa-manage-states' },
      //           exact: true,
      //         },
      //         {
      //           label: 'Cities',
      //           route: { name: 'sa-manage-cities' },
      //           exact: true,
      //         },
      //         {
      //           label: 'Universities',
      //           route: { name: 'manage-unis' },
      //           icon: { type: 'md-icon', id: 'chrome_reader_mode' },
      //         },
      //       ],
      //     },
      //     {
      //       label: 'Sponsorships',
      //       route: { name: 'scholarships-management-list' },
      //       icon: { type: 'md-icon', id: 'stars' },
      //     },
      //     {
      //       label: 'Prizes',
      //       icon: { type: 'md-icon', id: 'card_giftcard' },
      //       id: 'prize',
      //       children: [
      //         {
      //           label: 'School Prizes',
      //           route: { name: 'manage-prize' },
      //           exact: true,
      //         },
      //         {
      //           label: 'Redemptions',
      //           route: { name: 'manage-redeem-prizes' },
      //           exact: true,
      //         },
      //       ],
      //     },
      //   ],

      //   school: [
      //     {
      //       label: 'Home',
      //       route: { name: 'dashboard-school' },
      //       icon: { type: 'md-icon', id: 'home' },
      //     },
      //     {
      //       label: 'Students',
      //       icon: { type: 'md-icon', id: 'school' },
      //       id: 'students',
      //       children: [
      //         {
      //           label: 'Profiles',
      //           route: { name: 'schl-students-list' },
      //         },
      //         {
      //           label: 'Documents',
      //           route: { name: 'schl-std-secure-docs' },
      //           exact: true,
      //         },
      //         {
      //           label: 'Skills',
      //           route: { name: 'student-skill' },
      //         },
      //         {
      //           label: 'Questions',
      //           route: { name: 'student-questions' },
      //         },
      //         {
      //           label: 'Testimonials',
      //           route: { name: 'manage-student-testimonial-list' },
      //         },
      //       ],
      //     },
      //     // {
      //     //   label: 'Partnerships',
      //     //   icon: { type: 'md-icon', id: 'business' },
      //     //   id: 'partnerships',
      //     //   children: [
      //     //     {
      //     //       label: 'Employers',
      //     //       route: { name: 'manage-partnerships' },
      //     //     },
      //     //     {
      //     //       label: 'Universities',
      //     //       route: { name: 'manage-partnered-universities' },
      //     //       exact: true,
      //     //     },
      //     //   ],
      //     // },
      //     // {
      //     //   label: 'Resources',
      //     //   route: { name: 'school-manage-resources' },
      //     //   icon: { type: 'md-icon', id: 'folder' },
      //     //   id: 'resources',
      //     // },
      //     // {
      //     //   label: 'Employers',
      //     //   icon: { type: 'md-icon', id: 'business' },
      //     //   id: 'employers',
      //     //   children: [
      //     //     {
      //     //       label: 'Profiles',
      //     //       route: { name: 'schl-employers-list' },
      //     //     },
      //     //     {
      //     //       label: 'Partnerships',
      //     //       route: { name: 'manage-partnerships' },
      //     //       exact: true,
      //     //     },
      //     //   ],
      //     // },
      //   ],
      //   partner: [
      //     {
      //       label: 'Jobs',
      //       route: { name: 'partner-jobs-listing' },
      //       icon: { type: 'md-icon', id: 'work' },
      //       id: 'jobs',
      //     },
      //   ],
      //   employer: [
      //     {
      //       label: 'Home',
      //       route: { name: 'dashboard-employer' },
      //       icon: { type: 'md-icon', id: 'home' },
      //     },
      //     {
      //       label: 'Candidates',
      //       icon: { type: 'md-icon', id: 'school' },
      //       id: 'candidates',
      //       children: [
      //         {
      //           label: 'All Candidates',
      //           route: { name: 'employer-candidates-list' },
      //         },
      //         {
      //           label: 'Unlocked Candidates',
      //           route: { name: 'employer-unlocked-candidates-list', params: { to: 'unlock' } },
      //           exact: true,
      //         },
      //         {
      //           label: 'Hires',
      //           route: { name: 'hires' },
      //         },
      //       ],
      //     },
      //     {
      //       label: 'Training Providers',
      //       icon: { type: 'md-icon', id: 'account_balance' },
      //       id: 'training_providers',
      //       children: [
      //         {
      //           label: 'All Providers',
      //           route: { name: 'emp-schools-list' },
      //         },
      //         {
      //           label: 'Partnerships',
      //           route: { name: 'manage-partnerships' },
      //         },
      //       ],
      //     },
      //     {
      //       label: 'Sponsorships',
      //       icon: { type: 'md-icon', id: 'stars' },
      //       id: 'sponsorships',
      //       children: [
      //         {
      //           label: 'Postings',
      //           route: { name: 'scholarships-management-list' },
      //           exact: true,
      //         },
      //         {
      //           label: 'Questions',
      //           route: { name: 'emp-manage-questions' },
      //         },
      //         {
      //           label: 'Submissions',
      //           route: { name: 'std-apps-list' },
      //         },
      //       ],
      //     },
      //     {
      //       label: 'Jobs',
      //       route: { name: 'jobs-management-list' },
      //       icon: { type: 'md-icon', id: 'work' },
      //     },
      //   ],

      //   student: [
      //     {
      //       label: 'Jobs',
      //       icon: { type: 'md-icon', id: 'work' },
      //       children: [
      //         {
      //           label: 'All Jobs',
      //           route: { name: 'student-jobs-listing' },
      //           exact: true,
      //         },
      //         {
      //           label: 'Featured Jobs',
      //           route: { name: 'student-local-jobs-listing' },
      //           exact: true,
      //         },
      //       ],
      //     },
      //     {
      //       label: 'Companies',
      //       route: { name: 'student-employers-list' },
      //       icon: { type: 'md-icon', id: 'business' },
      //     },
      //     {
      //       label: 'Skills',
      //       route: { name: 'student-skill' },
      //       icon: { type: 'md-icon', id: 'videocam' },
      //     },
      //     // TODO: Uncomment after interviews integration.
      //     // {
      //     //   label: 'Interviews',
      //     //   route: { name: 'std-manage-resume' },
      //     //   icon: { type: 'md-icon', id: 'speaker_notes' },
      //     // },

      //     // TODO: Careers and events temporarily disabled for students.
      //     // {
      //     //   label: 'Careers',
      //     //   route: { name: 'student-careers' },
      //     //   icon: { type: 'md-icon', id: 'local_hospital' },
      //     // },
      //     // {
      //     //   label: 'Events',
      //     //   route: { name: 'student-events' },
      //     //   icon: { type: 'md-icon', id: 'event' },
      //     // },
      //   ],
      //   organization: [
      //     {
      //       label: 'Home',
      //       route: { name: 'org-admin-home' },
      //       icon: { type: 'md-icon', id: 'home' },
      //     },
      //     {
      //       label: 'Candidates',
      //       route: { name: 'org-students-list' },
      //       icon: { type: 'md-icon', id: 'school' },
      //     },
      //     {
      //       label: 'Schools',
      //       route: { name: 'org-schools-list' },
      //       icon: { type: 'md-icon', id: 'account_balance' },
      //     },
      //     {
      //       label: 'Jobs',
      //       route: { name: 'jobs-management-list' },
      //       icon: { type: 'md-icon', id: 'work' },
      //     },
      //     {
      //       label: 'Employers',
      //       route: { name: 'manage-org-employers' },
      //       icon: { type: 'md-icon', id: 'business' },
      //     },
      //     {
      //       label: 'Sponsorships',
      //       route: { name: 'scholarships-management-list' },
      //       icon: { type: 'md-icon', id: 'stars' },
      //     },

      //     {
      //       label: 'Initiative Sites',
      //       icon: { type: 'md-icon', id: 'settings' },
      //       id: 'website-config',
      //       children: [
      //         {
      //           label: 'Basic',
      //           route: { name: 'basic-config' },
      //           icon: { type: 'md-icon', id: 'settings' },
      //         },
      //         {
      //           label: 'Home',
      //           route: { name: 'homepage-config' },
      //           icon: { type: 'md-icon', id: 'settings' },
      //         },
      //         {
      //           label: 'Pages',
      //           route: { name: 'pages-config' },
      //           icon: { type: 'md-icon', id: 'settings' },
      //         },
      //       ],
      //     },
      //     {
      //       label: 'Application Questions',
      //       route: { name: 'manage-questions' },
      //       icon: { type: 'md-icon', id: 'help' },
      //     },
      //   ],
      //   unauthRoutes: [
      //     {
      //       label: 'Students',
      //       route: { name: 'sch-public-home' },
      //       icon: { type: 'md-icon', id: 'school' },
      //       exact: true,
      //     },
      //     {
      //       label: 'Employers',
      //       route: { name: 'sch-public-parnerships' },
      //       icon: { type: 'md-icon', id: 'business' },
      //       exact: true,
      //     },
      //     // {
      //     //   label: 'Interviews',
      //     //   route: { name: 'sch-public-interviews' },
      //     //   icon: { type: 'md-icon', id: 'speaker_notes' },
      //     //   exact: true,
      //     // },
      //     // {
      //     //   label: 'Careers',
      //     //   route: { name: 'sch-public-careers' },
      //     //   icon: { type: 'md-icon', id: 'local_hospital' },
      //     //   exact: true,
      //     // },
      //     // {
      //     //   label: 'Testimonials',
      //     //   route: { name: 'sch-public-testimonials' },
      //     //   icon: { type: 'md-icon', id: 'rate_review' },
      //     //   exact: true,
      //     // },
      //   ],
      // },
    };
  },
  computed: {
    ...mapGetters('auth', ['getLoggedInUser']),
    ...mapGetters('school', ['getCurrentSchool', 'getPaymentStatus']),
    ...mapGetters('partnership', ['getPartnershipStatus']),
    menu() {
      return {
        default: [
          {
            label: this.$t('home'),
            route: { name: 'home' },
            icon: { type: 'md-icon', id: 'home' },
          },
        ],
        superAdmin: [
          {
            label: this.$t('home'),
            route: { name: 'admin-dashboard' },
            icon: { type: 'md-icon', id: 'home' },
          },
          {
            label: 'Users',
            route: { name: 'manage-users' },
            icon: { type: 'md-icon', id: 'person' },
          },
          {
            label: 'Partnerships',
            route: { name: 'manage-all-partnerships' },
            icon: { type: 'md-icon', id: 'business' },
          },
          {
            label: 'Feature Updates',
            route: { name: 'manage-features' },
            icon: { type: 'md-icon', id: 'lightbulb' },
          },

          // {
          //   label: this.$t('schoolMsgs.schools'),
          //   route: { name: 'manage-schools' },
          //   icon: { type: 'md-icon', id: 'account_balance' },
          // },
          {
            label: this.$t('schoolMsgs.schools'),
            icon: { type: 'md-icon', id: 'account_balance' },
            id: 'schools-admin-account',
            children: [
              {
                label: 'School Accounts',
                route: { name: 'manage-schools' },
                icon: { type: 'md-icon', id: 'account_balance' },
              },
              {
                label: 'Interested Schools',
                route: { name: 'manage-interested-schools' },
                icon: { type: 'md-icon', id: 'account_balance' },
              },
            ],
          },
          {
            label: this.$t('studentMsgs.students'),
            route: { name: 'manage-students' },
            icon: { type: 'md-icon', id: 'school' },
          },
          {
            label: this.$t('employerMsgs.employers'),
            route: { name: 'manage-employers' },
            icon: { type: 'md-icon', id: 'business' },
          },
          {
            label: 'Organizations',
            route: { name: 'manage-organizations' },
            icon: { type: 'md-icon', id: 'business_center' },
          },
          {
            label: 'Advisors',
            route: { name: 'sa-manage-advisors' },
            icon: { type: 'md-icon', id: 'assignment_ind' },
          },
          {
            label: 'CampusGPTs',
            route: { name: 'manage-gpts' },
            icon: { type: 'md-icon', id: 'apps' },
          },
          {
            label: 'Partners',
            route: { name: 'manage-partners' },
            icon: { type: 'md-icon', id: 'group' },
          },
          {
            label: 'Initiative Sites',
            icon: { type: 'md-icon', id: 'settings' },
            id: 'website-config',
            children: [
              {
                label: 'Basic',
                route: { name: 'basic-config' },
                icon: { type: 'md-icon', id: 'settings' },
              },
              {
                label: 'Home',
                route: { name: 'homepage-config' },
                icon: { type: 'md-icon', id: 'settings' },
              },
              {
                label: 'Pages',
                route: { name: 'pages-config' },
                icon: { type: 'md-icon', id: 'settings' },
              },
            ],
          },

          {
            label: 'Programs',
            route: { name: 'sa-manage-programs' },
            icon: { type: 'md-icon', id: 'local_library' },
          },
          {
            label: 'Test Providers',
            route: { name: 'manage-test-providers' },
            icon: { type: 'md-icon', id: 'library_books' },
          },
          {
            label: 'LMS',
            icon: { type: 'md-icon', id: 'book' },
            id: 'lms-superadmin',
            children: [
              {
                label: 'Courses',
                route: { name: 'sa-list-courses' },
                exact: true,
              },
              {
                label: 'Lectures',
                route: { name: 'sa-list-lectures' },
                exact: true,
              },
              {
                label: 'Assignments',
                route: { name: 'sa-list-assignments' },
                exact: true,
              },
              {
                label: 'Assessments',
                route: { name: 'sa-list-quizzes' },
                exact: true,
              },
              {
                label: 'Library',
                route: { name: 'sa-skills-library' },
                exact: true,
              },
              {
                label: 'Student Progress',
                route: { name: 'sa-course-enrollments' },
                // icon: { type: 'md-icon', id: 'grade' },
                exact: true,
              },
              {
                label: 'AI Grading Config',
                route: { name: 'sa-ai-provider-config' },
                exact: true,
              },
            ],
          },
          {
            label: 'Jobs',
            route: { name: 'jobs-management-list' },
            icon: { type: 'md-icon', id: 'work' },
          },
          {
            label: 'Research',
            route: { name: 'research-management-list' },
            icon: { type: 'md-icon', id: 'menu_book' },
          },

          {
            label: 'Events',
            route: { name: 'sa-manage-events' },
            icon: { type: 'md-icon', id: 'event' },
          },
          {
            label: 'Blogs',
            route: { name: 'sa-manage-blogs' },
            icon: { type: 'md-icon', id: 'vignette' },
          },

          {
            label: 'Resources',
            route: { name: 'manage-resources' },
            icon: { type: 'md-icon', id: 'folder' },
          },
          {
            label: 'Skill Maps',
            route: { name: 'manage-skillmaps' },
            icon: { type: 'md-icon', id: 'map' },
          },
          {
            label: 'Skills Competitions',
            route: { name: 'sa-skills-competitions-list' },
            icon: { type: 'md-icon', id: 'emoji_events' },
          },
          {
            label: 'CareCampus',
            icon: { type: 'md-icon', id: 'location_on' },
            id: 'location',
            children: [
              {
                label: 'States',
                route: { name: 'sa-manage-states' },
                exact: true,
              },
              {
                label: 'Districts',
                route: { name: 'sa-manage-cities' },
                exact: true,
              },
              {
                label: 'Universities',
                route: { name: 'manage-unis' },
                icon: { type: 'md-icon', id: 'chrome_reader_mode' },
              },
              {
                label: 'Pathways',
                route: { name: 'sa-manage-pathways' },
                icon: { type: 'md-icon', id: 'route' },
              },
              {
                label: 'Societies',
                route: { name: 'sa-manage-societies' },
                icon: { type: 'md-icon', id: 'groups' },
              },
              {
                label: 'Testimonials',
                route: { name: 'sa-manage-tu-testimonials' },
                icon: { type: 'md-icon', id: 'format_quote' },
              },
              {
                label: 'Pathway Leads',
                route: { name: 'sa-manage-pathway-leads' },
                icon: { type: 'md-icon', id: 'person_add' },
              },
              {
                label: 'Pathway Enrollments',
                route: { name: 'sa-manage-pathway-enrollments' },
                icon: { type: 'md-icon', id: 'how_to_reg' },
              },
              {
                label: 'Connect requests',
                route: { name: 'sa-manage-connections' },
              },
            ],
          },
          {
            label: 'Careers',
            icon: { type: 'md-icon', id: 'assessment' },
            id: 'careers',
            children: [
              {
                label: 'Resumes',
                route: { name: 'user-resumes-list' },
              },
              {
                label: 'Career Pathways',
                route: { name: 'sa-manage-career-pathways' },
                icon: { type: 'md-icon', id: 'local_hospital' },
              },
              {
                label: 'Assessments',
                route: { name: 'manage-assessments' },
                icon: { type: 'md-icon', id: 'assessment' },
              },
            ],
          },
          // {
          //   label: 'Sponsorships',
          //   route: { name: 'scholarships-management-list' },
          //   icon: { type: 'md-icon', id: 'stars' },
          // },
          {
            label: 'Sponsorships',
            icon: { type: 'md-icon', id: 'stars' },
            id: 'sponsorships',
            children: [
              {
                label: 'Postings',
                route: { name: 'scholarships-management-list' },
                exact: true,
              },

              {
                label: 'Spotlights',
                route: { name: 'spotlight-list' },
              },

              {
                label: 'External',

                route: { name: 'external-scholarships-list' },
              },
            ],
          },
          {
            label: 'Interviews',
            icon: { type: 'md-icon', id: 'mic' },
            id: 'simulations',
            children: [
              {
                label: 'Listings',
                route: { name: 'simulations-management-list' },
                exact: true,
              },
              {
                label: 'Submissions',
                route: { name: 'simulations-submission-list' },
                exact: true,
              },
            ],
          },
          ...(this.getCurrentSchool && this.getCurrentSchool.voice_ai_phone
            ? [
                {
                  label: 'AI Assistant',
                  icon: { type: 'md-icon', id: 'bolt' },
                  id: 'calls-logs',
                  children: [
                    {
                      label: 'Call Logs',
                      route: { name: 'calls-logs' },
                      exact: true,
                    },
                  ],
                },
              ]
            : []),
          {
            label: 'Prizes',
            icon: { type: 'md-icon', id: 'card_giftcard' },
            id: 'prize',
            children: [
              {
                label: 'School Prizes',
                route: { name: 'manage-prize' },
                exact: true,
              },
              {
                label: 'Redemptions',
                route: { name: 'manage-redeem-prizes' },
                exact: true,
              },
            ],
          },
        ],

        school: [],
        school_home: [
          {
            label: 'Home',
            route: { name: 'dashboard-school' },
            icon: { type: 'md-icon', id: 'home' },
          },
        ],
        school_academics: [
          {
            id: 'reporting',
            label: 'Reporting',
            icon: { type: 'md-icon', id: 'assessment' },
            children: [
              {
                // Lands on the buckets page - General, Assessments and Assignments live inside it.
                // With LMS turned off there is nothing to report on, so send them to the same
                // disabled screen the LMS section uses.
                label: 'LMS',
                route: !get(this.getLoggedInUser, 'linked_entity.lms_enabled')
                  ? { name: 'lms-disabled' }
                  : { name: 'school-lms-analytics' },
              },
            ],
          },
          {
            label: 'Students',
            icon: { type: 'md-icon', id: 'school' },
            id: 'students',
            children: [
              {
                label: 'Profiles',
                route: { name: 'schl-students-list' },
              },
              {
                label: 'Documents',
                route: { name: 'schl-std-secure-docs' },
                exact: true,
              },
              {
                label: 'Exam Results',
                route: { name: 'school-exam-results' },
                exact: true,
              },
              {
                label: 'Testimonials',
                route: { name: 'manage-student-testimonial-list' },
              },
              // {
              //   label: 'Spotlights',
              //   route: { name: 'spotlight-list' },
              // },
            ],
          },

          ...([SCH_PAYMENT_PLANS.BASIC_PLAN, SCH_PAYMENT_PLANS.PAID_PLAN].includes(
            get(this.getLoggedInUser, 'linked_entity.sch_payment_plan.title'),
          )
            ? [
                {
                  label: 'Attendance',
                  icon: { type: 'md-icon', id: 'calendar_today' },
                  id: 'attendance',
                  children: [
                    {
                      label: 'Mark',
                      route: { name: 'mark-attendance' },
                      exact: true,
                    },
                    {
                      label: 'View',
                      route: { name: 'view-attendance' },
                      exact: true,
                    },
                  ],
                },
              ]
            : []),
          ...([SCH_PAYMENT_PLANS.PAID_PLAN].includes(get(this.getLoggedInUser, 'linked_entity.sch_payment_plan.title'))
            ? [
                {
                  label: 'Discussions',
                  route: { name: 'student-questions' },
                  icon: { type: 'md-icon', id: 'forum' },
                },
              ]
            : []),

          {
            label: 'Skills',
            icon: { type: 'md-icon', id: 'videocam' },
            id: 'skills',
            children: [
              {
                label: 'Library',
                route: { name: 'skills-library' },
                exact: true,
              },
              ...([SCH_PAYMENT_PLANS.PAID_PLAN].includes(
                get(this.getLoggedInUser, 'linked_entity.sch_payment_plan.title'),
              )
                ? [
                    {
                      label: 'Submissions',
                      route: { name: 'student-skill' },
                      exact: true,
                    },
                    {
                      label: 'Configuration',
                      route: { name: 'manage-skill-config' },
                      exact: true,
                    },
                  ]
                : []),
              ...(get(this.getLoggedInUser, 'linked_entity.skillform_config.games_enabled') ||
              get(this.getLoggedInUser, 'linked_entity.skillform_config.exams_enabled') ||
              get(this.getLoggedInUser, 'linked_entity.skillform_config.flashcards_enabled')
                ? [
                    {
                      label: 'Skillform',
                      route: { name: 'skillform-leaderboard' },
                      exact: true,
                    },
                  ]
                : []),
              ...(get(this.getLoggedInUser, 'role_type') === USER_ROLE_TYPES.SCHOOL &&
              get(this.getLoggedInUser, 'linked_entity.ai_skills_enabled')
                ? [
                    {
                      label: 'Cards',
                      route: { name: 'show-student-skillcard' },
                      exact: true,
                    },
                  ]
                : []),
            ],
          },
        ],
        school_lms: [
          ...(!get(this.getLoggedInUser, 'linked_entity.lms_enabled')
            ? [
                {
                  label: 'LMS',
                  icon: { type: 'md-icon', id: 'book' },
                  id: 'lms',
                  route: { name: 'lms-disabled' },
                },
              ]
            : [
                {
                  label: 'Courses',
                  route: { name: 'list-courses' },
                  icon: { type: 'md-icon', id: 'book' },
                  exact: true,
                },
                {
                  label: 'Student Progress',
                  route: { name: 'course-enrollments' },
                  icon: { type: 'md-icon', id: 'grade' },
                  exact: true,
                },
                {
                  label: 'Lectures',
                  route: { name: 'list-lectures' },
                  icon: { type: 'md-icon', id: 'ondemand_video' },
                  exact: true,
                },
                {
                  label: 'Assignments',
                  icon: { type: 'md-icon', id: 'assignment' },
                  id: 'assignments',
                  children: [
                    {
                      label: 'Listings',
                      route: { name: 'list-assignments' },
                      exact: true,
                    },
                    {
                      label: 'Submissions',
                      route: { name: 'list-graded-submissions' },
                      exact: true,
                    },
                  ],
                },
                {
                  label: 'Assessments',
                  icon: { type: 'md-icon', id: 'assessment' },
                  id: 'assessments',
                  children: [
                    {
                      label: 'Listings',
                      route: { name: 'list-quizzes' },
                      exact: true,
                    },
                    {
                      label: 'Submissions',
                      route: { name: 'list-quiz-submissions' },
                      exact: true,
                    },
                  ],
                },
              ]),
        ],
        school_tools: [
          {
            label: 'Tags',
            route: { name: 'manage-tags' },
            icon: { type: 'md-icon', id: 'local_offer' },
          },
          {
            label: 'Resources',
            route: { name: 'school-manage-resources' },
            icon: { type: 'md-icon', id: 'folder' },
          },
          {
            label: 'Email Configuration',
            route: { name: 'email-config-list' },
            icon: { type: 'md-icon', id: 'email' },
          },
          ...(this.getCurrentSchool && this.getCurrentSchool.voice_ai_phone
            ? [
                {
                  label: 'AI Assistant',
                  icon: { type: 'md-icon', id: 'bolt' },
                  id: 'calls-logs',
                  children: [
                    {
                      label: 'Call Logs',
                      route: { name: 'calls-logs' },
                      exact: true,
                    },
                  ],
                },
              ]
            : []),
        ],
        partner: [
          {
            label: 'Jobs',
            route: { name: 'partner-jobs-listing' },
            icon: { type: 'md-icon', id: 'work' },
            id: 'jobs',
          },
        ],
        employer_home: [
          {
            label: 'Dashboard',
            route: { name: 'dashboard-employer' },
            icon: { type: 'md-icon', id: 'home' },
          },
        ],
        employer_crm: [
          {
            label: 'Candidates',
            icon: { type: 'md-icon', id: 'school' },
            id: 'candidates',
            children: [
              {
                label: 'Associated Candidates',
                route: { name: 'associated-students-list', params: { to: 'associated' } },
                exact: true,
              },
              {
                label: 'All Candidates',
                route: { name: 'employer-candidates-list' },
              },
              {
                label: 'Unlocked Candidates',
                route: { name: 'employer-unlocked-candidates-list', params: { to: 'unlock' } },
                exact: true,
              },

              {
                label: 'Hires',
                route: { name: 'hires' },
              },
            ],
          },
          {
            label: 'Education Partners',
            icon: { type: 'md-icon', id: 'account_balance' },
            id: 'training_providers',
            children: [
              {
                label: 'All Schools',
                route: { name: 'emp-schools-list' },
              },
              {
                label: 'Partnerships',
                route: { name: 'manage-partnerships' },
              },
            ],
          },
        ],
        employer_tools: [
          {
            label: 'Interviews',
            icon: { type: 'md-icon', id: 'mic' },
            id: 'simulations',
            children: [
              {
                label: 'Listings',
                route: { name: 'simulations-management-list' },
                exact: true,
              },
              {
                label: 'Submissions',
                route: { name: 'simulations-submission-list' },
                exact: true,
              },
            ],
          },
          {
            label: 'Jobs',
            route: { name: 'jobs-management-list' },
            icon: { type: 'md-icon', id: 'work' },
          },
          {
            label: 'Sponsorships',
            icon: { type: 'md-icon', id: 'stars' },
            id: 'sponsorships',
            children: [
              {
                label: 'Postings',
                id: '1',
                route: { name: 'scholarships-management-list' },
                exact: true,
              },
              {
                label: 'Questions',
                id: '2',
                route: { name: 'emp-manage-questions' },
              },
              {
                label: 'Submissions',
                id: '3',
                route: { name: 'std-apps-list' },
              },
              {
                label: 'Spotlights',
                id: '4',
                route: { name: 'spotlight-list' },
              },
            ],
          },
        ],
        employer_cs_analytics: [
          ...(get(this.getLoggedInUser, 'linked_entity.organization')
            ? [
                {
                  label: 'Analytics',
                  icon: { type: 'md-icon', id: 'assessment' },
                  id: 'careers',
                  children: [
                    {
                      label: 'Resumes',
                      route: { name: 'user-resumes-list' },
                    },
                    {
                      label: 'Assessments',
                      route: { name: 'manage-assessments' },
                      icon: { type: 'md-icon', id: 'assessment' },
                    },
                  ],
                },
              ]
            : []),
        ],

        student: [
          {
            label: 'Jobs',
            icon: { type: 'md-icon', id: 'work' },
            children: [
              {
                label: 'All Jobs',
                route: { name: 'student-jobs-listing' },
                exact: true,
              },
              {
                label: 'Featured Jobs',
                route: { name: 'student-local-jobs-listing' },
                exact: true,
              },
            ],
          },
          {
            label: 'Companies',
            route: { name: 'student-employers-list' },
            icon: { type: 'md-icon', id: 'business' },
          },
          {
            label: 'Skills',
            route: { name: 'student-skill' },
            icon: { type: 'md-icon', id: 'videocam' },
          },
          // TODO: Uncomment after interviews integration.
          // {
          //   label: 'Interviews',
          //   route: { name: 'std-manage-resume' },
          //   icon: { type: 'md-icon', id: 'speaker_notes' },
          // },

          // TODO: Careers and events temporarily disabled for students.
          // {
          //   label: 'Careers',
          //   route: { name: 'student-careers' },
          //   icon: { type: 'md-icon', id: 'local_hospital' },
          // },
          // {
          //   label: 'Events',
          //   route: { name: 'student-events' },
          //   icon: { type: 'md-icon', id: 'event' },
          // },
          ...(get(this.getLoggedInUser, 'linked_entity.skillform_config.games_enabled') ||
          get(this.getLoggedInUser, 'linked_entity.skillform_config.exams_enabled') ||
          get(this.getLoggedInUser, 'linked_entity.skillform_config.flashcards_enabled')
            ? [
                {
                  label: 'Skillform',
                  route: { name: 'skillform-leaderboard' },
                  icon: { type: 'md-icon', id: 'sports_esports' },
                },
              ]
            : []),
        ],
        org_home: [
          {
            label: 'Dashboard',
            route: { name: 'org-admin-home' },
            icon: { type: 'md-icon', id: 'home' },
          },
          {
            id: 'analytics',
            label: 'Reporting',
            icon: { type: 'md-icon', id: 'assessment' },
            children: [
              {
                label: 'Participants',
                route: { name: 'org-analytics' },
                exact: true,
              },
            ],
          },
        ],
        org_crm: [
          {
            label: 'Participants',
            icon: { type: 'md-icon', id: 'school' },
            id: 'candidates',
            children: [
              {
                label: 'Associated Participants',
                route: { name: 'associated-students-list', params: { to: 'associated' } },
                exact: true,
              },
              {
                label: 'All Participants',
                route: { name: 'org-students-list' },
              },
              {
                label: 'Unlocked Participants',

                route: { name: 'org-unlock-students-list', params: { to: 'unlock' } },
                exact: true,
              },
            ],
          },
          // {
          //   label: 'Candidates',
          //   route: { name: 'org-students-list' },
          //   icon: { type: 'md-icon', id: 'school' },
          // },
          {
            label: 'Education Partners',
            route: { name: 'org-schools-list' },
            icon: { type: 'md-icon', id: 'account_balance' },
          },
          {
            label: 'Employer Partners',
            route: { name: 'manage-org-employers' },
            icon: { type: 'md-icon', id: 'business' },
          },
          {
            label: 'Advisors',
            route: { name: 'manage-org-advisors' },
            icon: { type: 'md-icon', id: 'assignment_ind' },
          },
        ],
        org_tools: [
          ...(get(this.getLoggedInUser, 'linked_entity.enable_discussions') && this.isOrgToolEnabled('discussions')
            ? [
                {
                  label: 'Discussions',
                  route: { name: 'org-questions-list' },
                  icon: { type: 'md-icon', id: 'forum' },
                },
              ]
            : []),
          ...(get(this.getLoggedInUser, 'linked_entity.enable_bulk_messaging') && this.isOrgToolEnabled('bulk_emails')
            ? [
                {
                  label: 'Bulk Emails',
                  route: { name: 'org-bulk-messaging' },
                  icon: { type: 'md-icon', id: 'email' },
                },
              ]
            : []),
          ...(get(this.getLoggedInUser, 'linked_entity.enable_bulk_messaging') && this.isOrgToolEnabled('bulk_sms')
            ? [
                {
                  label: 'Bulk SMS',
                  route: { name: 'org-bulk-sms-messaging' },
                  icon: { type: 'md-icon', id: 'sms' },
                },
              ]
            : []),
          {
            label: 'Verifications',
            route: { name: 'org-exam-results' },
            icon: { type: 'md-icon', id: 'verified_user' },
          },
          ...(this.isOrgToolEnabled('interviews')
            ? [
                {
                  label: 'Interviews',
                  icon: { type: 'md-icon', id: 'mic' },
                  id: 'simulations',
                  children: [
                    {
                      label: 'Listings',
                      route: { name: 'simulations-management-list' },
                      exact: true,
                    },
                    {
                      label: 'Submissions',
                      route: { name: 'simulations-submission-list' },
                      exact: true,
                    },
                  ],
                },
              ]
            : []),
          {
            label: 'Jobs',
            route: { name: 'jobs-management-list' },
            icon: { type: 'md-icon', id: 'work' },
          },
          ...(this.isOrgToolEnabled('research')
            ? [
                {
                  label: 'Research',
                  route: { name: 'research-management-list' },
                  icon: { type: 'md-icon', id: 'menu_book' },
                },
              ]
            : []),
          ...(this.isOrgToolEnabled('sponsorships')
            ? [
                {
                  label: 'Sponsorships',
                  icon: { type: 'md-icon', id: 'stars' },
                  id: 'sponsorships',
                  children: [
                    {
                      label: 'Postings',
                      route: { name: 'scholarships-management-list' },
                      exact: true,
                    },
                    {
                      label: 'Questions',
                      route: { name: 'manage-questions' },
                    },
                    {
                      label: 'Spotlights',
                      route: { name: 'spotlight-list' },
                    },
                  ],
                },
              ]
            : []),
          ...(this.isOrgToolEnabled('events')
            ? [
                {
                  label: 'Events',
                  route: { name: 'manage-org-events' },
                  icon: { type: 'md-icon', id: 'event' },
                },
              ]
            : []),
          {
            label: 'Resources',
            route: { name: 'manage-org-resources' },
            icon: { type: 'md-icon', id: 'folder' },
          },
        ],
        org_cs: [
          {
            label: 'Build Site',
            icon: { type: 'md-icon', id: 'settings' },
            id: 'website-config',
            children: [
              {
                label: 'Settings',
                route: { name: 'basic-config' },
                icon: { type: 'md-icon', id: 'settings' },
              },
              {
                label: 'Homepage',
                route: { name: 'homepage-config' },
                icon: { type: 'md-icon', id: 'settings' },
              },
              {
                label: 'Pages',
                route: { name: 'pages-config' },
                icon: { type: 'md-icon', id: 'settings' },
              },
            ],
          },
          {
            label: 'Website Analytics',
            icon: { type: 'md-icon', id: 'assessment' },
            id: 'careers',
            children: [
              {
                label: 'Resumes',
                route: { name: 'user-resumes-list' },
              },
              {
                label: 'Assessments',
                route: { name: 'manage-assessments' },
                icon: { type: 'md-icon', id: 'assessment' },
              },
              {
                label: 'Inquiries',
                route: { name: 'org-inquiries-list' },
                icon: { type: 'md-icon', id: 'comment' },
              },
            ],
          },
        ],

        unauthRoutes: [
          {
            label: 'For Students',
            route: { name: 'sch-public-home' },
            icon: { type: 'md-icon', id: 'school' },
            exact: true,
          },
          {
            label: 'For Employers',
            route: { name: 'sch-public-parnerships' },
            icon: { type: 'md-icon', id: 'business' },
            exact: true,
          },
          // {
          //   label: 'Interviews',
          //   route: { name: 'sch-public-interviews' },
          //   icon: { type: 'md-icon', id: 'speaker_notes' },
          //   exact: true,
          // },
          // {
          //   label: 'Careers',
          //   route: { name: 'sch-public-careers' },
          //   icon: { type: 'md-icon', id: 'local_hospital' },
          //   exact: true,
          // },
          // {
          //   label: 'Testimonials',
          //   route: { name: 'sch-public-testimonials' },
          //   icon: { type: 'md-icon', id: 'rate_review' },
          //   exact: true,
          // },
        ],
      };
    },
  },
  watch: {
    scrollIntoViewElement: 'scrollIntoView',
    getPaymentStatus: {
      immediate: true,
      deep: true,
      handler(value) {
        if (value && this.$refs['schoolSideMenu']) {
          this.schoolKey = 'schoolId';
          this.$refs['schoolSideMenu'].$forceUpdate();
        }
      },
    },
    // getCurrentSchool: {
    //   immediate: true,
    //   deep: true,
    //   handler() {
    //     if (this.$refs['schoolSideMenu']) {
    //       this.$refs['schoolSideMenu'].$forceUpdate();
    //     }
    //   },
    // },
  },
  created() {
    this.$root.$on('fmv::sidebar-menu::state', ({ targetId, opened }) => {
      this.updateSidebarScroll();
      if (opened) {
        this.scrollIntoViewElement = targetId;
      }
    });
    if (get(this.getLoggedInUser, 'role_type') === USER_ROLE_TYPES.SCHOOL) {
      this.fetchPendingPartnerships();
    }
  },
  methods: {
    ...mapActions('school', ['getSchool']),
    ...mapActions('partnership', ['updatePendingPartnershipStatus']),
    get,

    // Org sidebar tools are configurable per organization from super admin.
    // Anything not present in the saved config defaults to enabled.
    isOrgToolEnabled(abbr) {
      const tools = get(this.getLoggedInUser, 'linked_entity.sidebar_tools_config.sidebar_tools');
      if (!tools || !tools.length) return true;
      const tool = tools.find((t) => t.abbr === abbr);
      return tool ? !!tool.enable : true;
    },

    async fetchPendingPartnerships() {
      this.arePartnershipPending = true;

      this.updatePendingPartnershipStatus();
      this.arePartnershipPending = false;
    },
    emitState(targetId, opened, open) {
      const state = {
        targetId,
        open,
        opened,
      };
      this.$root.$emit('fmv::sidebar-menu::state', state);
    },
    linkComponent(route) {
      this.$router.push(route);
    },
    openStdModal() {
      this.showStdModal = true;
    },
    hideStdModal() {
      this.showStdModal = false;
    },
    updateSidebarScroll() {
      this.$nextTick(() => {
        if (this.$refs.sidebar) {
          this.$refs.sidebar.update();
        }
      });
    },
    scrollIntoView() {
      this.$nextTick(() => {
        const target = document.querySelector(`#${this.scrollIntoViewElement}`);
        if (target) {
          elementScrollIntoView(target, {
            behavior: 'smooth',
            block: 'end',
            inline: 'nearest',
          });
        }
      });
    },
    getClickableLink(link) {
      return link.startsWith('http://') || link.startsWith('https://') ? link : `https://${link}`;
    },
  },
};
</script>
